import gql from 'graphql-tag';

const GET_ALL_ADVANCE_POLICY_RULES = gql`
  query getAllAdvancePolicyRules {
    getAllAdvancePolicyRules {
      state
      lastPublishedTime
      data {
        assetClass {
          name
          classId
        }
        isPreview
        rules {
          id
          name
          description
          ruleCondition
          ruleOrder
          ruleType
          assetClass {
            classId
            name
          }
          policyCategory {
            policyCategoryId
            name
          }
          ruleVersion
          createdTime
          updatedTime
        }
      }
    }
  }
`;

const GET_ASSET_COUNTS_FOR_RULES = gql`
  query {
    getAssetCountsForRules {
      overriddenCount
      rulesCount {
        ruleId
        previewedCount
        publishedCount
        newlyOnboardedCount
      }
    }
  }
`;

const GET_PUBLISHED_ASSETS_BY_RULE = gql`
  query getPublishedAssetsByRule($ruleId: ID!, $listInfo: ListInfoInput!) {
    getPublishedAssetsByRule(ruleId: $ruleId, listInfo: $listInfo) {
      assets {
        assetId
        name
        customFields(fields: [])
        assetClass {
          classId
          name
        }
        client {
          name
          accountId
        }
      }
      listInfo {
        page
        pageSize
        totalCount
        hasMore
      }
    }
  }
`;

const GET_PREVIEWED_ASSETS_BY_RULE = gql`
  query getPreviewedAssetsByRule($ruleId: ID!, $listInfo: ListInfoInput!) {
    getPreviewedAssetsByRule(ruleId: $ruleId, listInfo: $listInfo) {
      assets {
        assetId
        name
        customFields(fields: [])
        client {
          name
          accountId
        }
        assetClass {
          classId
          name
        }
        policyCategory {
          name
        }
        nextPolicyCategory {
          name
        }
      }
      listInfo {
        page
        pageSize
        totalCount
        hasMore
      }
    }
  }
`;

const GET_OVERRIDDEN_ASSETS = gql`
  query getOverriddenAssets($listInfo: ListInfoInput!) {
    getOverriddenAssets(listInfo: $listInfo) {
      assets {
        assetId
        name
        customFields(fields: [])
        client {
          name
          accountId
        }
        assetClass {
          classId
          name
        }
        policyCategory {
          name
        }
        categoryAssignedStrategy
      }
      listInfo {
        page
        pageSize
        totalCount
        hasMore
      }
    }
  }
`;

export {
  GET_ALL_ADVANCE_POLICY_RULES,
  GET_ASSET_COUNTS_FOR_RULES,
  GET_PUBLISHED_ASSETS_BY_RULE,
  GET_PREVIEWED_ASSETS_BY_RULE,
  GET_OVERRIDDEN_ASSETS
};
